import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDeliveryList extends BaseModelAPI {

	static entity = 'surat jalan deliverylist'
	static entityName = 'suratjalandelivery';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
